import React from "react";
import CrowdCanvas from "../animations/CrowdCanvas";
import allPeepsImg from "../../../assets/images/all-peeps.png";
import GreetingText from "../common/GreetingText";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";
import MailTo from "../animations/MailTo";

export default function ContactContainer({setIsNavigating}) {

  const isMobile = window.innerWidth < 768;
  const {cursor} = useCursor()




  const scrollToSection = (id) => {

  setIsNavigating(true);

  const target = document.getElementById(id);

  if (!target) {
    setIsNavigating(false);
    return;
  }

  target.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });

  let lastY = window.scrollY;
  let stableFrames = 0;

  const checkScroll = () => {

    const currentY = window.scrollY;

    if (Math.abs(currentY - lastY) < 1) {
      stableFrames++;
    } else {
      stableFrames = 0;
    }

    lastY = currentY;

    // Scroll position stayed almost unchanged
    // for several frames → scrolling finished
    if (stableFrames >= 8) {
      setIsNavigating(false);
      return;
    }

    requestAnimationFrame(checkScroll);
  };

  requestAnimationFrame(checkScroll);
  };




  return (
    <section 
    {...cursor({...CURSORS.contact,text:"",border:"1px solid #fff",background:"",blendMode:"difference",size:50})}
    className="relative min-h-screen w-full overflow-hidden bg-white text-black">

      <div className="h-[8vh] sm:h-[8vh] lg:h-[10vh]" />

      {/* FOOTER CONTENT */}
      <div className="relative z-10 flex min-h-[82vh] w-full flex-col justify-between px-6 pt-8 pb-[28vh] sm:px-8 sm:pt-10 sm:pb-[25vh] md:px-12 md:pb-[23vh] lg:px-20 lg:pt-16 lg:pb-[20vh]">

        {/* TOP / MAIN CONTENT */}
        <div className="flex w-full flex-col gap-12 lg:flex-row lg:justify-between lg:gap-8">

          {/* LEFT */}
          <div className="w-full lg:w-[55%]">

            {/* Say Hi */}
            <div>
              <GreetingText
                interval={2000}
                greetings={[
                  { text: "hi", lang: "en" },
                  { text: "namaste", lang: "hi" },
                  { text: "hola", lang: "es" },
                ]}
              />

              {/* Email */}
              {/* <a 
              {...cursor({...CURSORS.contact,text:"",background:"#fff",blendMode:"difference",size:30})}
              href="mailto:hi.badushapareed@gmail.com" className="block w-fit font-pixeloperator text-[30px] leading-none tracking-[1px] transition-opacity duration-300 hover:opacity-50 sm:text-[24px] md:text-[30px] lg:text-[38px] xl:text-[42px]">
                hi.badushapareed@gmail.com
              </a> */}
              <MailTo/>
            </div>

            {/* Description */}
            <p className="mt-7 max-w-[620px] font-['Space_Mono'] text-[9px] leading-[1.7] text-black/65 sm:text-[10px] md:text-xs">
              I’m a developer who enjoys turning ideas into thoughtful, functional digital products. 
              Whether you’re looking to build something new, improve an existing product, or collaborate on an interesting idea, 
              I’d love to hear what you’re working on and see how I can help.
            </p>

          </div>

          {/* RIGHT */}
          <div className="flex w-full flex-col pt-2 lg:w-[42%] lg:items-end lg:pt-6">

            <div className="flex w-full justify-between gap-8">

              {/* SOCIALS */}
              <div>
                <h3 className="mb-4 font-pixeloperator text-[25px] leading-none sm:text-[28px] md:text-[31px]">
                  Connect Me
                </h3>

                <div 
                className="flex flex-col gap-3 text-[12px] sm:text-[13px] md:text-[14px]">
                  <a 
                  {...cursor({...CURSORS.contact,text:"",border:"1px solid #fff",background:"",blendMode:"difference",size:20})}
                  href="www.linkedin.com/in/badusha-pareed" className="font-['Space_Mono'] group w-fit text-black/70 transition-colors hover:text-black">
                    <div className="w-fit">
                      <h1
                      
                      >Linked In</h1>
                      <div className="h-[1px] w-0 bg-black transition-all duration-500 group-hover:w-full" />
                    </div>
                  </a>

                  <a 
                  {...cursor({...CURSORS.contact,text:"",border:"1px solid #fff",background:"",blendMode:"difference",size:20})}
                  href="https://github.com/badu01/" className="font-['Space_Mono'] group w-fit text-black/70 transition-colors hover:text-black">
                    <div className="w-fit">
                      <h1>Github</h1>
                      <div className="h-[1px] w-0 bg-black transition-all duration-500 group-hover:w-full" />
                    </div>
                  </a>

                  <a 
                  {...cursor({...CURSORS.contact,text:"",border:"1px solid #fff",background:"",blendMode:"difference",size:20})}
                  href="https://www.instagram.com/b.a.d.u._?igsh=ZmM5bDgzNHBwMWY%3D" className="font-['Space_Mono'] group w-fit text-black/70 transition-colors hover:text-black">
                    <div className="w-fit">
                      <h1>Instagram</h1>
                      <div className="h-[1px] w-0 bg-black transition-all duration-500 group-hover:w-full" />
                    </div>
                  </a>
                </div>
              </div>

              {/* NAVIGATION */}
              <nav className="flex flex-col items-end gap-3 font-pixeloperator text-[18px] sm:text-xl md:text-2xl">
                <div 
                {...cursor({...CURSORS.contact,text:"",background:"#fff",blendMode:"difference",size:20})}
                className="group flex items-center gap-x-2">
                  <div className="hidden h-[7px] w-[7px] rounded-full bg-black group-hover:block" />
                  <p onClick={()=>scrollToSection('home')} className="transition-opacity group-hover:opacity-50">Home</p>
                </div>

                <div 
                {...cursor({...CURSORS.contact,text:"",background:"#fff",blendMode:"difference",size:20})}
                className="group flex items-center gap-x-2">
                  <div className="hidden h-[7px] w-[7px] rounded-full bg-black group-hover:block" />
                  <p onClick={()=>scrollToSection('experience')} className="transition-opacity group-hover:opacity-50">Experience</p>
                </div>

                <div 
                {...cursor({...CURSORS.contact,text:"",background:"#fff",blendMode:"difference",size:20})}
                className="group flex items-center gap-x-2">
                  <div className="hidden h-[7px] w-[7px] rounded-full bg-black group-hover:block" />
                  <p onClick={()=>scrollToSection('projects')} className="transition-opacity group-hover:opacity-50">Projects</p>
                </div>

                <div 
                {...cursor({...CURSORS.contact,text:"go to top",color:"#000", background:"#fff",blendMode:"difference",size:150})}
                className="group flex items-center gap-x-2">
                  <div className="hidden h-[7px] w-[7px] rounded-full bg-black group-hover:block" />
                  <button onClick={()=>scrollToSection('home')} className="text-[#1100FF] hover:text-transparent transition-opacity group-hover:opacity-50">
                    Back to top
                  </button>
                </div>
              </nav>

            </div>
          </div>
        </div>

        {/* HANDWRITTEN NAME */}
        <div className="mt-2 flex w-full flex-col items-center justify-center sm:mt-8 md:mt-4">

          <img src="/name_animation.svg" alt="Badusha" className="h-auto w-[190px] max-w-full object-contain sm:w-[240px] md:w-[300px] lg:w-[300px]" />

          <div className="mt-5 flex w-full flex-row justify-between gap-2 text-center font-['Space_Mono'] text-[9px] text-black/70 sm:text-[10px] md:text-left md:text-[11px] lg:text-[12px]">

            <h1>
              <span className="font-sans text-black/70">©</span> 2026 Badusha Pareed
            </h1>

            <h1>made with ❤️ in kerala</h1>

            <a 
            {...cursor({...CURSORS.contact,text:"",color:"#000", background:"#fff",blendMode:"difference",size:20})}
            href="https://github.com/badu01/portfolio.git" className="hidden md:block hover:text-black">
              source code
            </a>

          </div>
        </div>

      </div>

      {/* CROWD */}
      <div className="pointer-events-none absolute bottom-0 left-0 z-0  h-[28vh] w-full sm:h-[30vh] md:h-[34vh] lg:h-[38vh]">

        <CrowdCanvas
          src={allPeepsImg}
          rows={15}
          cols={7}
          peepCount={isMobile ? 15 : 50}
          speed={1}
          minSpeed={0.7}
          maxSpeed={1.3}
          direction="random"
          bounce={true}
          bounceHeight={8}
          peepScale={0.12}
          verticalSpread={8}
          verticalOffset={100}
        />
      </div>

    </section>
  );
}